import { fluid } from '@helpers/fluid';
import { contentStyles } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import SectionWrapper from '@stories/Components/Global/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Container = styled(SectionWrapper) `
  color: var(--fgColor);

  ${ButtonStyles.Container} {
    margin-top: ${fluid(24, 32)};
  }
`;
const Inner = styled.div `
  max-width: 89ch;
  margin: 0 auto;
`;
const Content = styled.div `
  ${contentStyles};
`;
const RichTextStyles = {
    Container,
    Content,
    Inner,
};
export default RichTextStyles;
